// Pipeline.jsx
import React, { useEffect, useRef, useState } from "react";
import AdminAppBar from "../adminComponents/AdminAppBar";
import KanbanBoard from "./KanbanBoard";
import ShimmerKanban from "./ShimmerKanban";
import teamService from "../Services/TeamService";
import propertyService from "../Services/PropertyService";
import PipelineFilter from "./PipelineFilter";
import { MdFilterListAlt } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import CustomButton from "../common/CustomButton";
import CustomChip from "../common/CustomChip";
import { department, teamIds } from "../../utils/storage";
import { TbMapSearch } from "react-icons/tb";
import DealService from "../Services/DealService";
import Card from "./Card";
import { IoIosArrowBack } from "react-icons/io";
import ColumnData from "../pipelineComponents/ColumnData";
import { dealStagesData } from "../../Enum/PipelineEnumConstants.js";
import { showInfoToast } from "../Constant/Notification.js";
import { FiSearch } from "react-icons/fi";
import TeamService from "../../GlobalSetupComponents/Services/TeamService.js";
import UserService from "../../GlobalSetupComponents/Services/UserService.js";
import {
  managementDepartmentLabel,
  salesDepartmentLabel,
} from "../../GlobalSetupComponents/Enum/DepartmentEnum.js";

const Pipeline = () => {
  const [teams, setTeams] = useState([{ name: "All Team", id: "All Team" }]);
  const [properties, setProperties] = useState([
    { name: "All Property", id: "All Property" },
  ]);
  const [users, setUsers] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");
  const navigate = useNavigate();
  const [selectedProperty, setSelectedProperty] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedUserDetails, setSelectedUserDetails] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [dealLeadsData, setDealLeadsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [dealData, setDealData] = useState([]);
  const [showDeals, setShowDeals] = useState(false);
  const [showDealInfoCallback, setShowDealInfoCallback] = useState(null);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const showDealInfoRef = useRef(null);

  useEffect(() => {
    (async () => {
      try {
        if (userRole === "Admin" || userRole === "CMO" || userRole === "BOD") {
          const response = await TeamService.getDepartmentTeamList({
          department : salesDepartmentLabel
          });
          
          setTeams(response.data?.map((team) => ({ name: team.label, teamId: team.value })) || []);
        } else if (userRole === "MD") {
          setTeams(userData.teamId.map((team) => ({ name: team.name, teamId: team.id })));
          setTempSelectedTeam();
        }

        const propResponse = await propertyService.getPropertiesName();
        setProperties([...propResponse.data.properties]);

        // const userResponse = await teamService.getUserName();
        // setUsers(userResponse.data.users);
        const userResponse = await UserService.getDepartmentWithTeamMembers({
          departmentNames: [managementDepartmentLabel, salesDepartmentLabel],
        });
        setUsers(userResponse.data.users);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, []);

  const defaultTeamId = Array.isArray(teamIds)
    ? teamIds.length > 0 ? teamIds[0] : "" : teamIds || ""; 

  const [tempSelectedTeam, setTempSelectedTeam] = useState(defaultTeamId);

  const [tempSelectedProperty, setTempSelectedProperty] = useState("");
  const [tempSelectedUser, setTempSelectedUser] = useState("");

  const handleTeamChange = (value) => {
    setTempSelectedTeam(value);
    setTempSelectedUser(null);
  };

  const handlePropertyChange = (value) => {
    setTempSelectedProperty(value);
    setTempSelectedUser(null);
  };

  const handleUserChange = (value) => {
    setTempSelectedUser(value);
    const userName = users.find((item) => item.id === value)?.name || "";
    setSelectedUserDetails(userName);
    setTempSelectedTeam(null);
    setTempSelectedProperty(null);
  };

  const applyFilter = () => {
    const userId = tempSelectedUser !== "" ? tempSelectedUser : null;

    if (userId) {
      const path = userRole === "Admin" ? "/admin" : "/cmo";
      navigate(`${path}/pipline-user-deal`, {
        state: {
          userId: userId,
          userName: selectedUserDetails,
          userList: users,
        },
      });
      return;
    }
    console.log("Selected Team:", tempSelectedTeam);
    console.log("Selected Property:", tempSelectedProperty);

    setSelectedTeam(tempSelectedTeam === "All Team" ? null : tempSelectedTeam);
    setSelectedProperty(
      tempSelectedProperty === "All Property" ? null : tempSelectedProperty
    );
    setVisible(false);
  };

  const handleRemoveFilter = (type) => {
    if (type === "team") {
      setTempSelectedTeam("");
      setSelectedTeam("");
    } else if (type === "property") {
      setTempSelectedProperty("");
      setSelectedProperty("");
    } else if (type === "user") {
      setTempSelectedUser("");
      setSelectedUser("");
      setSelectedUserDetails("");
    }
    setVisible(false);
  };

  const clearFilters = () => {
    if (userRole === "BOD") {
      setTempSelectedTeam(defaultTeamId);
    } else {
      setTempSelectedTeam("");
    }
    setTempSelectedProperty("");
    setTempSelectedUser("");
    setSelectedTeam("");
    setSelectedProperty("");
    setSelectedUser("");
    setSelectedUserDetails("");
  };

  const handleFilterDeal = () => {
    setVisible(true);
  };

  const selectedLeadDeals = async (LeadId) => {
    try {
      const body = {
        leadId: LeadId,
        next: "",
        direction: "",
        limit: 20,
      };
      const response = await DealService.getLeadDeals(body);
      console.log("Selected Lead Deals:", response.data);
      const tasks = response.data.deals.map((item) => {
        let status = item.scheduleStatus || "";
        let dateMDY = item.scheduledDate || "";
        let time = item.scheduledTime || "";

        if (item.scheduledTime && !dateMDY) {
          dateMDY = item.scheduledTime?.scheduledDate;
          time = item.scheduledTime?.scheduledTime;
        }

        return {
          id: item.id,
          squareFeet: `${item.squareFeet} Sq feet`,
          approx: [
            "Plot Booked",
            "Advance Amount Update",
            "Fully Registered",
            "Registration InProgress",
            "Deal Lost After Booking",
          ].includes(item.currentStage)
            ? "Fixed"
            : "Approx",
          status,
          icon: "",
          customerName: item.lead,
          siteName: item.property,
          propertyId: item.propertyId,
          stage: item.currentStage,
          teamMemberName: item.responsiblePerson?.name,
          teamDetail: item.team,
          teamId: item.teamId,
          day: dateMDY,
          time,
          bookedTimestamp: item.bookedDaysCount,
          recentComment: item.lastComment,
        };
      });
      setDealData(tasks);
      setShowDeals(true);
    } catch (error) {
      console.error("Error fetching selected lead deals:", error);
    }
  };

  const getDealLeadsData = async () => {
    try {
      const body = {
        searchKey: searchQuery,
        next: "",
        direction: "",
        limit: 10,
      };
      const response = await DealService.getDealLeads(body);
      console.log("Deal Leads Data:", response.data);
      setDealLeadsData(response.data.leads);
    } catch (error) {
      setDealLeadsData([]);
      console.error("Error fetching deal leads data:", error);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearch = () => {
    getDealLeadsData();
  };

  const handleBackToLeads = () => {
    setShowDeals(false);
    setDealData([]);
  };

  const handleCardClick = (task) => {
    const showDealInfoCallback = showDealInfoRef.current;

    console.log("handleCardClick called with task:", task);
    if (typeof showDealInfoCallback === "function") {
      const stage = task.stage;

      if (!dealStagesData[stage]) {
        console.error(`Stage "${stage}" not found in dealStagesData`);
        return;
      }

      const column = {
        title: stage,
        stageId: dealStagesData[stage],
        bgColor:
          ColumnData.find((col) => col.title === stage)?.bgColor || "#FFFFFF",
      };

      console.log(
        "Calling showDealInfoCallback with task:",
        task,
        "column:",
        column
      );
      showDealInfoCallback(task, column);
    } else {
      console.error("showDealInfoCallback is not set or not a function");
    }
  };

  const receiveShowDealInfoFromChild = (fn) => {
    console.log("Received showDealInfo from child:", fn);
    showDealInfoRef.current = fn;
  };

  useEffect(() => {
    if (isSearchOpen) {
      setShowDeals(false);
      setDealData([]);
      setSearchQuery("");
      getDealLeadsData();
    }
  }, [isSearchOpen]);


  return (
    <div className="bg-appGrayBackground overflow-y-hidden">
      <AdminAppBar />
      <div className="pt-4 px-10 xl:px-6 mt-20 flex justify-between">
        <h1 className="text-4xl font-bold xl:text-3xl">Sales Pipeline</h1>
        <div className="flex items-center gap-4">
          <div
            onClick={() => {
              setIsSearchOpen(!isSearchOpen);
              setVisible(false);
            }}
            className="bg-customGreen cursor-pointer text-base font-medium w-12 h-12 rounded-full justify-center flex items-center gap-3 text-customGreen p-2 hover:bg-appGreenHover transition duration-300"
          >
            <TbMapSearch className="text-white text-2xl" />
          </div>
          <button
            onClick={handleFilterDeal}
            className="bg-white justify-between text-base font-medium w-[131px] h-[50px] rounded-[10px] flex items-center gap-3 text-customGreen py-2 px-4 hover:bg-appGreenHover transition duration-300"
          >
            Filters
            <MdFilterListAlt />
          </button>
        </div>
      </div>

      <div className="flex gap-3 items-center px-10 mt-4">
        {selectedTeam || selectedProperty ? (
          <>
            Applied Filters:
            {selectedTeam &&
              selectedTeam !== "All Team" &&
              userRole !== "BOD" && (
                <CustomChip
                  value={
                    teams.find((team) => team.teamId === selectedTeam)?.name ||
                    selectedTeam
                  }
                  onRemove={() => handleRemoveFilter("team")}
                />
              )}
            {selectedProperty && selectedProperty !== "All Property" && (
              <CustomChip
                value={
                  properties.find(
                    (property) => property.id === selectedProperty
                  )?.name || selectedProperty
                }
                onRemove={() => handleRemoveFilter("property")}
              />
            )}
          </>
        ) : null}
      </div>

      <div className="">
        {loading ? <ShimmerKanban /> : ""}
        <KanbanBoard
          team={selectedTeam}
          property={selectedProperty}
          setLoading={setLoading}
          userList={users}
          onCardClick={receiveShowDealInfoFromChild}
        />
        <PipelineFilter
          visible={visible}
          onHide={() => setVisible(false)}
          teams={teams}
          properties={properties}
          users={users}
          handleApplyFilter={applyFilter}
          clearFilters={clearFilters}
          selectedUser={tempSelectedUser}
          selectedTeam={tempSelectedTeam}
          selectedProperty={tempSelectedProperty}
          handleTeamChange={handleTeamChange}
          handlePropertyChange={handlePropertyChange}
          handleUserChange={handleUserChange}
          errors={{}}
        />
      </div>

      {isSearchOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-xl shadow-2xl w-11/12 md:w-1/2 lg:w-1/3 max-h-[80vh] overflow-hidden">
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                {showDeals && (
                  <button onClick={handleBackToLeads} className="text-gray-500">
                    <IoIosArrowBack className="text-2xl" />
                  </button>
                )}
                <h2 className="text-lg font-semibold text-gray-800">
                  {showDeals ? "Deal Details" : "Search Leads"}
                </h2>
              </div>
              <button
                onClick={() => setIsSearchOpen(false)}
                className="text-gray-500 hover:text-red-600 transition"
              >
                ✕
              </button>
            </div>

            {!showDeals && (
              <div className="relative mb-4">
                <input
                  type="text"
                  placeholder="Search by Lead Name or Phone Number"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                  className="w-full h-[50px] p-2 border border-gray-300 rounded-md  input-focus  "
                />
                <button
                  type="submit"
                  className="absolute right-0 top-0 h-[50px] w-[50px] bg-customGreen text-white rounded-r-[10px] flex items-center justify-center hover:bg-green-600 transition"
                >
                  <FiSearch size={20} />
                </button>
              </div>
            )}

            <div className="overflow-y-auto max-h-[50vh] space-y-3">
              {showDeals ? (
                dealData.length > 0 ? (
                  dealData.map((task, index) => (
                    <div key={index} onClick={() => handleCardClick(task)}>
                      <Card
                        title={task.stage || "Site Name"}
                        task={task}
                        dealId={task.id}
                        index={index}
                      />
                    </div>
                  ))
                ) : (
                  <p className="text-center text-gray-500">
                    No deals found for this lead.
                  </p>
                )
              ) : dealLeadsData.length > 0 ? (
                dealLeadsData.map((lead, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      if (lead.dealsCount > 0) {
                        selectedLeadDeals(lead.id);
                      } else {
                        showInfoToast("No deals found for this lead.");
                        return;
                      }
                    }}
                    className="p-3 border cursor-pointer flex justify-between items-start rounded-md shadow-sm hover:bg-gray-100 transition"
                  >
                    <div>
                      <p className="text-base truncate w-[250px] font-medium text-gray-800  ">
                        {lead.name}
                      </p>
                      <p className="text-sm text-gray-600">
                        {lead.countryCode}
                        {lead.phoneNumber}
                      </p>
                    </div>
                    <div className="bg-customGreen text-white text-xs rounded-2xl px-3 py-1 mt-2">
                      Deal Count: {lead.dealsCount}
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500">No leads found.</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pipeline;
